module.exports = __webpack_public_path__ + "portal/assets/img/logo.07caf6e9.svg";